module.exports = __webpack_public_path__ + "img/innovations_medium.cb91a2b8.webp";